
export default function Square(props: any){
	let { children } = props;
	return <>{children}</>
}